import React, { useEffect, useState, useMemo } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
import tabelaPeso from "../../assets/images/tournaments/lijjam-combat-ix-de-jiu-jitsu-2026/tabela-lijjam-combat-ix-de-jiu-jitsu-2026.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import desceGelo from "../../assets/images/sponsors/desce-gelo.jpeg";
import drGuarana from "../../assets/images/sponsors/dr-guarana.png";
import fireBoy from "../../assets/images/sponsors/fire-boy.png";
import ligaDeJiuJitsu from "../../assets/images/sponsors/liga-de-jiu-jitsu.png";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

//Apoio
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from "@mui/material";
import Papa from "papaparse";

const sponsors = [
  { img: desceGelo },
  { img: drGuarana },
  { img: fireBoy },
  { img: ligaDeJiuJitsu },
  { img: torneio, url: "http://www.torneiofacil.com" },
];

const support = [
  { img: torneio, url: "http://www.torneiofacil.com" },
];

const dataEvento = "13 e 14 de junho de 2026"
const horaEvento = "9:00h da manhã"
const tituloEvento = "LIJJAM Combat IX de Jiu Jitsu Gi e Nogi"
const localEvento = "Ginásio Nininberg Guerra"
const endereçoEvento = "R. Barão do Rio Branco, 320 - São Jorge, Manaus - AM, CEP 69033-430"
const dataDeEncerramentoIncricao = "09/JUN/2026"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "09/JUN/2026"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLote1 = "01/JUN/2026"
const dataDeEncerramentoInscricaoLote2 = "09/JUN/2026"

const valorinscricaoCategoriaLote1 = "70,00 (setenta reais)"
const valorinscricaoCategoriaLote2 = "80,00 (oitenta reais)"

const dataDeDivulgacaoChaves = "12/JUN/2026"
const horaDeDivulgacaoChaves = "23h:59min"

const dataDeDivulgacaoCronograma = " EM BREVE"
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "(92) 99468-5161"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi";
const slugNOGI = "lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi";
const rotaChecagemGi = "/check/lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi/search";
const rotaChecagemNoGi = "/check/lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi/search";
const rotaChavesGi = "/tournament/keys/lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi";
const rotaChavesNoGi = "/tournament/keys/lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi";


const LijjamCombatIxDeJiuJitsu2026: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();
  const [chavesModalOpen, setChavesModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const normalizeKey = (key: string) =>
    key
      .replace(/\s+/g, " ")
      .replace(/\n/g, " ")
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  useEffect(() => {
    fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vRNFVN84QBmaq4XBDmjlgd6FTfLN2HB8iUfPR2YNGIyHpkkCE8gBoK8JNzh8pByEcIgc5MvllPJ9jwB/pub?gid=738523974&single=true&output=csv")
      .then((res) => res.text())
      .then((csvText) => {
        const parsed = Papa.parse(csvText, { header: true });
        setRows(parsed.data);
      });
  }, []);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`);
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const filteredRows = useMemo(() => {
    if (!search.trim()) return rows;

    const query = search.toLowerCase();
    const matchedIndices = new Set<number>();

    rows.forEach((row, i) => {
      const nome = Object.entries(row).find(([k]) =>
        normalizeKey(k).includes("nome")
      )?.[1];
      const academia = Object.entries(row).find(([k]) =>
        normalizeKey(k).includes("academia")
      )?.[1];
      const inscricao = Object.entries(row).find(([k]) =>
        normalizeKey(k).includes("insc")
      )?.[1];

      const textValues = [nome, academia, inscricao]
        .map((v) => String(v || "").toLowerCase())
        .join(" ");

      if (textValues.includes(query)) {
        const start = i % 2 === 0 ? i : i - 1;
        matchedIndices.add(start);
        matchedIndices.add(start + 1);
      }
    });

    return rows.filter((_, i) => matchedIndices.has(i));
  }, [search, rows]);

  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/lijjam-combat-ix-de-jiu-jitsu-2026/lijjam-combat-ix-de-jiu-jitsu-2026.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/lijjam-combat-ix-de-jiu-jitsu-2026/lijjam-combat-ix-de-jiu-jitsu-2026.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/vjPK4TMBK9ax2v828"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index}
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank"
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    A {tituloEvento} é um evento tradicional de LUTAS CASADAS que
                    fomenta e incentiva a prática do jiu jitsu na cidade de Manaus-Am . As lutas
                    serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PREMIAÇÕES: CINTURÃO + DINHEIRO💰">
                  <H3>Academias:</H3>
                  <P>1° lugar: R$5.000,00 + Cinturão de Campeão</P>
                  <P>2° lugar: R$3.000,00 + Cinturão de Segundo Lugar</P>
                  <P>3° lugar: R$2.000,00 + Cinturão de Terceiro Lugar</P>
                  <P>4° lugar: R$1.000,00 </P>
                  <P>5° lugar: R$500,00 </P>
                  <P>6° lugar: R$500,00 </P>
                  <P>7° lugar: R$500,00 </P>
                  <P>8° lugar: R$500,00 </P>
                  <P>9° lugar: R$500,00 </P>
                  <P>10° lugar: R$500,00 </P>

                  <br />
                  <H3>Categorias GI e NOGI</H3>
                  <P>Campeão: Cinturão</P>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    Só serão aceitas inscrições de atletas filiados à LIJJAM.
                  </Span>
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente à idade que o atleta
                    completará no ano de 2026, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2026.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às{' '}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada logo após a inscrição.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Checagem</H3>
                  <P>
                    Checagem é o ato de verificar os dados da inscrição.
                  </P>
                  <P>
                    A checagem por número de inscrição, por academia e por nome do atleta ficará disponível até o término do torneio.
                  </P>
                  <br />
                  <H3>Chaves/Lutas</H3>
                  <P>
                    A divulgação das chaves/lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                </Collapse>

                <Collapse title="FILIAÇÃO">
                  <Span>
                    Haverá possibilidade de uso de cupom de desconto somente na afiliação. Verificar com o organizador do evento a disponibilidade de cupons de desconto.
                  </Span>
                </Collapse>

                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <H3>Lote 1 - Pagamento até {dataDeEncerramentoInscricaoLote1}</H3>
                  <P>Inscrição GI R$ {valorinscricaoCategoriaLote1}</P>
                  <P>Inscrição NOGI R$ {valorinscricaoCategoriaLote1}</P>
                  <br />
                  <H3>Lote 2 - Pagamento até {dataDeEncerramentoInscricaoLote2} (último dia de inscrição)</H3>
                  <P>Inscrição GI R$ {valorinscricaoCategoriaLote2}</P>
                  <P>Inscrição NOGI R$ {valorinscricaoCategoriaLote2}</P>
                  <br />
                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                  </H3>
                  <P>
                    1) Quando o evento é CANCELADO.
                  </P>
                  <P>
                    2) Quando ocorre alteração na DATA do evento.
                  </P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                    após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                  </H3>
                  <P>
                    5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico
                    comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta
                    usufrui do reembolso de 80% do valor pago na inscrição.
                  </P>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                    o atleta NÃO TEM direito ao reembolso.
                  </P>
                  <P>
                    Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data
                    do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                  </P>
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                  </H3>
                  <P>
                    1) Está sozinho na chave de luta.
                  </P>
                  <P>
                    2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                  </P>
                  <P>
                    3) Desistência por qualquer motivo.
                  </P>
                </Collapse>

                <Collapse title="REGRAS">
                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    O {tituloEvento} é um evento de lutas casadas e a organização do evento casará as lutas conforme
                    critérios próprios. Serão casados idade, faixa e peso aproximados. O atleta não tem direito a
                    reclamação sobre o casamento das lutas.
                  </Span>
                  <Span>
                    A vestimenta das lutas GI (com kimono) e NOGI (sem kimono) seguirá o padrão da CBJJ e IBJJF, conforme o livro de regras disponível no final dessa seção.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento momentos antes da luta. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem, ou a carteira da LIJJAM.
                    Poderá ser apresentada a carteira digital de filiação na LIJJAM, que será verificada via QR Code
                    para confirmar a autenticidade e se o atleta está em dia.
                  </Span>
                  <Span>
                    Atletas que ultrapassarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados.
                  </Span>
                  <Span>
                    A fim de evitar chaves sem lutas, o esquema de faixa usado será o seguinte:
                  </Span>
                  <P>Branca;</P>
                  <P>Cinza, Amarela, Laranja e Verde (Graduados - lutam juntas);</P>
                  <P>Azul;</P>
                  <P>Roxa;</P>
                  <P>Marrom;</P>
                  <P>Preta.</P>
                  <Span>
                    Atletas de 16 e 17 anos só serão aceitos nas faixas Branca, Azul e Roxa.
                  </Span>

                  <Span>Será realizada apenas uma pesagem oficial por atleta. Em caso de ultrapassar o peso informado na inscrição, o atleta será desclassificado.</Span>
                  <Span>A arbitragem será composta por equipe de árbitros das federações do
                    Amazonas de Jiu-Jitsu.
                  </Span>
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso, mesmo que tenha passado na filiação.
                  </Span>
                  <Span>
                    Tolerância de 15 minutos a partir do horário marcado para a luta para a
                    decretação do W.O.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Modalidade GI e NOGI juntas (a pontuação é a mesma)</H5>
                  <P>1° lugar: 3 Pontos</P>
                  <P>2° lugar: 1 Ponto</P>
                  <P>Campeão direto (sem adversário na chave): 2 Pontos</P>
                  <P>Campeão por W.O. (adversário desistiu): 3 Pontos</P>
                  <br />
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as lutas GI e NOGI juntas.
                  </P>
                  <P>
                    Não haverá luta casada entre atletas da mesma academia.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                  <Container>
                    <span>LIJJAM Combat IX</span>
                    <h5>Em breve</h5>
                    {/* <h5>09:00 - Lutas 01 a 40</h5>
                    <h5>09:30 - Lutas 41 a 80</h5>
                    <h5>10:00 - Lutas 81 a 110</h5>
                    <h5>10:30 - Lutas 111 a 140</h5>
                    <h5>11:00 - Lutas 141 a 160</h5>
                    <h5>11:30 - Lutas 161 a 190</h5>
                    <h5>12:00 - Lutas 191 a 220</h5>
                    <h5>12:30 - Lutas 221 a 250</h5>
                    <h5>13:00 - Lutas 251 a 280</h5>
                    <h5>13:30 - Lutas 281 a 300</h5>
                    <h5>14:00 - Lutas 301 a 320</h5>
                    <h5>14:30 - Lutas 321 a 340</h5>
                    <h5>15:00 - Lutas 341 a 370</h5>
                    <h5>15:30 - Lutas 371 a 400</h5>
                    <h5>16:00 - Lutas 401 a 430</h5>
                    <h5>16:30 - Lutas 431 a 460</h5>
                    <h5>17:00 - Lutas 461 a 490</h5>
                    <h5>17:30 - Lutas 491 a 520</h5>
                    <h5>18:00 - Lutas 521 a 550</h5>
                    <h5>18:30 - Lutas 551 a 580</h5>
                    <h5>19:00 - Lutas 581 a 640</h5>

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>O cronograma pode ser adiantado em até 30 minutos, e atrasar até 10h devido as necessidades do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 30 minutos antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss */}
                  </Container>
                </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href={`https://whatsa.me/5592994685161/?t=Ol%C3%A1!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*LIJJAM%20Combat%20IX%20DE%20JIU%20JITSU%202026*`}>
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href={`https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*LIJJAM%20Combat%20IX%20DE%20JIU%20JITSU%202026*`}
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentLink
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>

              <TournamentLink
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink>

              <TournamentLink
                onClick={() => setChavesModalOpen(true)}
              >
                Chaves
              </TournamentLink>

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />

      <Dialog
        open={chavesModalOpen}
        onClose={() => setChavesModalOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1,
            borderBottom: "1px solid #ddd",
          }}
        >
          <DialogTitle sx={{ m: 0, p: 0, fontWeight: "bold" }}>Chaves</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setChavesModalOpen(false)}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <TextField
          fullWidth
          placeholder="Pesquisar por nome, inscrição ou academia..."
          value={search}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          sx={{ px: 2, py: 1 }}
        />

        <DialogContent sx={{ p: 0, height: "80vh" }}>
          <div style={{ padding: 20 }}>
            <h3>Chaves {tituloEvento}</h3>
            <table
              border={1}
              cellPadding={6}
              style={{
                borderCollapse: "collapse",
                width: "100%",
                textAlign: "center",
              }}
            >
              <thead style={{ backgroundColor: "#f5f5f5" }}>
                <tr>
                  {rows[0] &&
                    Object.keys(rows[0]).map((key) => <th key={key}>{key}</th>)}
                </tr>
              </thead>

              <tbody>
                {filteredRows.map((row, i) => (
                  <tr key={i}>
                    {Object.entries(row).map(([key, val], j) => {
                      const normalizedKey = normalizeKey(key);

                      if (normalizedKey.includes("luta") && i % 2 === 0) {
                        return (
                          <td
                            key={j}
                            rowSpan={2}
                            style={{
                              textAlign: "left",
                              verticalAlign: "middle",
                              width: 90,
                              background: "#fafafa",
                            }}
                          >
                            {String(val)}
                          </td>
                        );
                      }

                      if (normalizedKey.includes("nº insc.")) {
                        return (
                          <td
                            key={j}
                            style={{
                              textAlign: "left",
                              verticalAlign: "center",
                              width: 90
                            }}
                          >
                            {String(val)}
                          </td>
                        );
                      }

                      if (normalizedKey.includes("luta") && i % 2 !== 0) return null;

                      return (
                        <td
                          key={j}
                          style={{
                            textAlign: "left",
                            verticalAlign: "middle",
                          }}
                        >
                          {String(val)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LijjamCombatIxDeJiuJitsu2026;
